// Stylesheets
import './assets/scss/site.scss';

import { fillHeight } from './assets/modules/fillHeight';
import { fluidvideo } from './assets/modules/fluidvideo';
import { popup } from './assets/modules/popup';
import { copyUrl } from './assets/modules/copyUrl';
import { hover } from './assets/modules/hover';
import { formSelect } from './assets/modules/form';
import { marquee } from './assets/modules/marquee';
import { scrollDirection } from './assets/modules/scrollDirection';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe-init';
import { slideList } from './assets/modules/slideList';
import { carousel } from './assets/modules/carousel';
import { stickySidebar } from './assets/modules/stickySidebar';
import { trigger } from './assets/modules/trigger';
import { pushStateHandler } from './assets/modules/pushState';
import { headerFixed } from './assets/modules/headerFixed';
import { logo } from './assets/modules/logo';
import { motionLogo } from './assets/modules/motionLogo';
import { viewerVertical } from './assets/modules/viewerVertical';
import { bounceText } from './assets/modules/bounceText';
import { archiveLogoSwitcher } from './assets/modules/archiveLogoSwitcher';
import { fileUpload } from './assets/modules/fileUpload';

const init = () => {
  fillHeight();
  fluidvideo();
  popup();
  copyUrl();
  hover();
  formSelect();
  marquee();
  scrollDirection();
  initPhotoSwipeFromDOM('.js-pswp-container');
  slideList();
  carousel();
  stickySidebar();
  trigger();
  pushStateHandler();
  headerFixed();
  logo();
  motionLogo();
  viewerVertical();
  bounceText();
  archiveLogoSwitcher();
  fileUpload();
}

init();